// https://docs.fineuploader.com/tag/3.8.2/features/handling-errors.html
export default {
  'it-IT': {
    close: 'Chiudi',
    whyDoISeeThisPrice: 'Perché vedo questo prezzo?',
    attenderePrego: 'Attendere prego...',
    language: 'Lingua',
    country: 'Nazione',
    currency: 'Valuta',
    confirm: 'Conferma',
    cancel: 'Annulla',
    save: 'Salva',
    edit: 'Modifica',
    sortingBy: 'Ordina per',
    consent: 'Acconsenti',
    alsoVisit: 'Visita anche',
    showAll: 'Visualizza tutti',
    notFoundHeader: 'La pagina che stavi cercando non esiste o è stata rimossa',
    search: 'Cerca',
    discoverNow: 'Scopri ora',
  },
  'fr-FR': {
    close: 'Fermer',
    whyDoISeeThisPrice: 'Pourquoi est-ce que je vois ce prix?',
    attenderePrego: "Patientez s'il vous plaît...",
    language: 'Langue',
    country: 'Pays',
    currency: 'Devise',
    confirm: 'Confirmer',
    cancel: 'Annuller',
    save: 'Enregistrer',
    edit: 'Modifier',
    sortingBy: 'Trier par ',
    consent: 'Autoriser',
    alsoVisit: 'Visitez aussi',
    showAll: 'Tout afficher',
    notFoundHeader:
      'La page que vous cherchez est introuvable ou a été supprimée',
    search: 'Rechercher',
    discoverNow: 'Découvrir maintenant',
  },
  'es-ES': {
    close: 'Cerrar',
    whyDoISeeThisPrice: '¿Por qué veo este precio?',
    attenderePrego: 'Por favor, espere...',
    language: 'Idioma',
    country: 'País',
    currency: 'Moneda',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Salvar',
    edit: 'Editar',
    sortingBy: 'Ordenar por',
    consent: 'Aceptar',
    alsoVisit: 'Visita también',
    showAll: 'Ver todo',
    notFoundHeader: 'La página que está buscando no existe o ha sido eliminada',
    search: 'Buscar',
    discoverNow: 'Descubrir ahora',
  },
  'en-GB': {
    close: 'Close',
    whyDoISeeThisPrice: 'Why do I see this price?',
    attenderePrego: 'Please wait...',
    language: 'Language',
    country: 'Country',
    currency: 'Currency',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    sortingBy: 'Sort by',
    consent: 'Agree',
    alsoVisit: 'Visit',
    showAll: 'View all',
    notFoundHeader:
      'The page you were looking for does not exist or has been removed',
    search: 'Search',
    discoverNow: 'Discover now',
  },
  'en-US': {
    close: 'Close',
    whyDoISeeThisPrice: 'Why do I see this price?',
    attenderePrego: 'Please wait...',
    language: 'Language',
    country: 'Country',
    currency: 'Currency',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    sortingBy: 'Sort by',
    consent: 'Agree',
    alsoVisit: 'Visit',
    showAll: 'View all',
    notFoundHeader:
      'The page you were looking for does not exist or has been removed',
    search: 'Search',
    discoverNow: 'Discover now',
  },
  'de-DE': {
    close: 'Schließen',
    whyDoISeeThisPrice: 'Warum sehe ich diesen Preis?',
    attenderePrego: 'Bitte warten...',
    language: 'Sprachen',
    country: 'Land',
    currency: 'Währung',
    confirm: 'Bestätigen',
    cancel: 'Schließen',
    save: 'Speichern',
    edit: 'Bearbeiten',
    sortingBy: 'Filtern nach',
    consent: '',
    alsoVisit: 'Besuchen Sie auch',
    showAll: 'Alle anzeigen',
    notFoundHeader:
      'Die von Ihnen gesuchte Seite existiert leider nicht oder wurde entfernt.',
    search: 'Suchen',
    discoverNow: 'Jetzt Entdecken',
  },
  'en-AU': {
    close: 'Close',
    whyDoISeeThisPrice: 'Why do I see this price?',
    attenderePrego: 'Please wait...',
    language: 'Language',
    country: 'Country',
    currency: 'Currency',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    sortingBy: 'Sort by',
    consent: 'Agree',
    alsoVisit: 'Visit',
    showAll: 'View all',
    notFoundHeader:
      'The page you were looking for does not exist or has been removed',
    search: 'Search',
    discoverNow: 'Discover now',
  },
  'ko-KR': {
    close: '닫기',
    whyDoISeeThisPrice: 'Why do I see this price?',
    attenderePrego: 'Please wait...',
    language: '언어',
    country: '국가',
    currency: '화폐',
    confirm: '확인',
    cancel: '취소',
    save: '',
    edit: '',
    sortingBy: 'Sort by',
    consent: 'Agree',
    alsoVisit: 'Visit',
    showAll: 'View all',
    notFoundHeader:
      'The page you were looking for does not exist or has been removed',
    search: 'Search',
    discoverNow: 'Discover now',
  },
  'ja-JP': {
    close: 'Close',
    whyDoISeeThisPrice: 'Why do I see this price?',
    attenderePrego: '少々お待ちください...',
    language: '言語',
    country: '国・地域 半角英数字',
    currency: '通貨',
    confirm: 'OK',
    cancel: 'キャンセル',
    save: '',
    edit: '',
    sortingBy: 'Sort by',
    consent: 'Agree',
    alsoVisit: 'Visit',
    showAll: 'View all',
    notFoundHeader:
      'The page you were looking for does not exist or has been removed',
    search: 'Search',
    discoverNow: 'Discover now',
  },
};
